import request from '@/utils/request';

/* eslint-disable */
const actions = {
  async addCancelOrderReason({ dispatch, commit }, { cancelOrderReason }) {
    try {
      const { data } = await request.post(
        'cancelOrderReasons',
        cancelOrderReason,
      );

      if (data.error) {
        throw Error('Server-side validation failed');
      }
    } catch (err) {
      throw err;
    }
  },
};

export default actions;
